import React from "react";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";

const useStyles = createUseStyles((theme) => ({
	wrapperVip: {
		marginBottom: "20px",
	},
	wrapper: {},
	stubVipContainer: {
		height: "100px",
		width: "100%",
		background: theme.palette.colors.disabled,
		"&:first-child": {
			borderTopLeftRadius: "10px",
			borderTopRightRadius: "10px",
		},
		"&:last-child": {
			borderBottomLeftRadius: "10px",
			borderBottomRightRadius: "10px",
		},
	},
	stubContainer: {
		height: "100px",
		width: "100%",
		background: theme.palette.colors.disabled,
		"&:first-child": {
			borderTopLeftRadius: "10px",
			borderTopRightRadius: "10px",
		},
		"&:last-child": {
			borderBottomLeftRadius: "10px",
			borderBottomRightRadius: "10px",
		},
	},
	[`@media (min-width: ${theme.media.operatorListSmall}) and (max-width: ${theme.media.sm})`]: {
		wrapperVip: {
			marginBottom: 0,
		},
		stubVipContainer: {
			height: "152px",
			marginBottom: "16px",
			borderRadius: "10px",
		},
		stubContainer: {
			height: "152px",
			marginBottom: "16px",
			borderRadius: "10px",
		},
	},
	[`@media (max-width: ${theme.media.operatorListSmall})`]: {
		wrapperVip: {
			marginBottom: 0,
		},
		stubVipContainer: {
			height: "172px",
			marginBottom: "16px",
			borderRadius: "10px",
		},
		stubContainer: {
			height: "172px",
			marginBottom: "16px",
			borderRadius: "10px",
		},
	},
}));

const StubOperatorsList = (props) => {
	const classes = useStyles();

	const generateVipStub = () => {
		let array = [];
		for (let i = 0; i < props.amountVip; i++) {
			array.push(<div key={i} className={classes.stubVipContainer} />);
		}

		return array;
	};

	const generateStub = () => {
		let array = [];
		for (let i = 0; i < props.amount - props.amountVip; i++) {
			array.push(<div key={i + props.amountVip} className={classes.stubContainer} />);
		}

		return array;
	};

	return (
		<PaddingBottom>
			<Container>
				<div className={classes.wrapperVip}>{generateVipStub()}</div>
				<div className={classes.wrapper}>{generateStub()}</div>
			</Container>
		</PaddingBottom>
	);
};

export default StubOperatorsList;
